import { useEffect, useState } from 'react';
import { SalesController } from './interfaces';
import { SalePropertyDto } from 'services/sales/sale.dto';
import { useAPISalesService } from 'services/sales/sales.service';
import { useMessenger } from 'tools/view-hooks/messenger-hook';

export const useSalesController = (
    salesService = useAPISalesService(),
    messenger = useMessenger(),
): SalesController => {
    const [isLoading, setIsLoading] = useState(false);
    const [saleProperties, setSaleProperties] = useState<SalePropertyDto[]>([]);
    const [mlConnected, setMlConnected] = useState(false);
    const [mlAuthUrl, setMlAuthUrl] = useState('');
    const [isMarkModalVisible, setIsMarkModalVisible] = useState(false);

    useEffect(() => {
        fetchSaleProperties();
        fetchMLStatus();
    }, []);

    const fetchSaleProperties = () => {
        setIsLoading(true);
        salesService
            .listSaleProperties()
            .then(setSaleProperties)
            .catch(() => messenger.showErrorMessage({ key: 'Error al cargar propiedades en venta' }))
            .finally(() => setIsLoading(false));
    };

    const fetchMLStatus = () => {
        salesService
            .getMLStatus()
            .then(({ url, connected }) => {
                setMlConnected(connected);
                setMlAuthUrl(url);
            })
            .catch((error) => {
                console.log(JSON.stringify(error));
            });
    };

    const onMarkForSalePressed = () => setIsMarkModalVisible(true);
    const onMarkForSaleCanceled = () => setIsMarkModalVisible(false);

    const onPropertyMarked = (sp: SalePropertyDto) => {
        setIsMarkModalVisible(false);
        setSaleProperties((prev) => [sp, ...prev]);
    };

    const onPropertyRemoved = (salePropertyId: number) => {
        setSaleProperties((prev) => prev.filter((sp) => sp.id !== salePropertyId));
    };

    const onPropertyUpdated = (updated: SalePropertyDto) => {
        setSaleProperties((prev) => prev.map((sp) => (sp.id === updated.id ? updated : sp)));
    };

    const onListingUpdated = (_salePropertyId: number, updatedSp: SalePropertyDto) => {
        setSaleProperties((prev) => prev.map((sp) => (sp.id === updatedSp.id ? updatedSp : sp)));
    };

    return {
        isLoading,
        saleProperties,
        mlConnected,
        mlAuthUrl,
        isMarkModalVisible,
        onMarkForSalePressed,
        onMarkForSaleCanceled,
        onPropertyMarked,
        onPropertyRemoved,
        onPropertyUpdated,
        onListingUpdated,
        salesService,
    };
};
